<template lang="pug">
.input-number-component
    label.input-label-number {{ label }}
    input.input-number(
        :id='id',
        type='number',
        :placeholder='placeholder',
        :value='value',
        @input='$emit("input", $event.target.value)'
    )
</template>

<script>
export default {
    name: 'NumberInputComponent',
    props: {
        value: {},
        id: {
            type: String,
            default: () => `number-input-${Math.ceil(Math.random() * 10000)}`,
        },

        label: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: '',
        },
    },
};
</script>

<style>
.input-number-component {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-wrap: wrap;
}

.input-number {
    margin: 5px 0 10px 0;
    padding: 3px;
    height: 30px;
    border: 2px solid var(--primary-light-green) !important;
    border-radius: 5px;
}

.input-number:focus-visible {
    border: 2px solid var(--primary-green) !important;
    border-radius: 5px;
    outline: none;
}
</style>
